'use strict';
const BaseComponent = require('../../../../shared/base');

class UserPreferredLocation extends BaseComponent {
    render() {
        return null;
    }
}

module.exports = UserPreferredLocation;